/*
 * File: Store.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/17/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Orders app store view functions
 */
import { getEnv } from "mobx-state-tree";
import AppStore from "Store";

const OrdersAppViews = self => ({
  buildQueryString(filtersPref, filterTabValue = "all") {
    let queryParameters = new URLSearchParams();
    queryParameters.append("offset", self.pageNumber);
    if (filterTabValue === "mine") {
      queryParameters.append(
        "user",
        getEnv(self).storeManager.getStore(AppStore).userId
      );
    }
    filtersPref.getUrl(queryParameters);
    return queryParameters.toString();
  },
  get hasNextPage() {
    return self.pageNumber < self.totalPageCount;
  }
});

export default OrdersAppViews;
